import React, { useEffect, useState } from "react";
import ReactMarkdown from "react-markdown";
import "../styles/Markdown.css"; // Import your CSS styles here

const MarkdownViewer: React.FC = () => {
    const [markdown, setMarkdown] = useState<string>("");

    useEffect(() => {
        fetch("example.md") // from public/
            .then((res) => res.text())
            .then(setMarkdown)
            .catch(console.error);
    }, []);

    return (
        <div className="markdown-container">
            <ReactMarkdown>{markdown}</ReactMarkdown>
        </div>
    );
};

export default MarkdownViewer;